export enum NotebookActionType {
  Add = '[Notebook] Add',
  AddSuccess = '[Notebook] AddSuccess',
  AddFailure = '[Notebook] AddFailure',
  AddNotebookResourcesOnSuccess = '[Notebook] Add Notebook Resources on success',
  SaveReport = '[Notebook] SaveReport',

  Destroy = '[Notebook] Destroy',
  DestroyFailure = '[Notebook] DestroyFailure',
  DestroySuccess = '[Notebook] DestroySuccess',

  Init = '[Notebook] Init',
  InitComplete = '[Notebook] InitComplete',
  LoadWithInit = '[Notebook] LoadWithInit',
  LoadWithInitSuccess = '[Notebook] LoadWithInitSuccess',

  LoadFromSelectedReport = '[Notebook] LoadFromSelectedReport',
  LoadFailure = '[Notebook] LoadFailure',
  LoadSuccess = '[Notebook] LoadSuccess',

  UpdateType = '[Notebook] Patch',
  UpdateTypeFailure = '[Notebook] PatchFailure',
  UpdateSuccess = '[Notebook] PatchSuccess',

  Run = '[Notebook] Run',
  CancelRun = '[Notebook] CancelRun',
  CancelRunComplete = '[Notebook] CancelRunComplete',
  CancelRunSuccess = '[Notebook] CancelRunSuccess',
  RunFailed = '[Notebook] RunFailed',
  CreateRunSuccess = '[Notebook] CreateRunSuccess',
  InitialRunSuccess = '[Notebook] InitialRunSuccess',
  Idle = '[Notebook] Idle',
  SessionBusy = '[Notebook] SessionBusy',
  SessionMetrics = '[Notebook] SessionMetrics',
  DataLoaded = '[Notebook] DataLoaded',
  Terminated = '[Notebook] Terminated',
  Disconnected = '[Notebook] Disconnected',
  ClearAllCellOutputs = '[Notebook] Clear All Cell Outputs',

  NoSession = '[Notebook] NoSession',
  InitSession = '[Notebook] InitSession',
  InitSessionFailure = '[Notebook] InitSessionFailure',
  VerifySession = '[Notebook] VerifySession',
  LoadSessionSuccess = '[Notebook] LoadSessionSuccess',
  RefreshSessionReportRun = '[Notebook] RefreshSessionReportRun',

  PollSession = '[Notebook] PollSession',
}
